/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetDataAttendanceWidgetData } from './WidgetDataAttendanceWidgetData';
import {
    WidgetDataAttendanceWidgetDataFromJSON,
    WidgetDataAttendanceWidgetDataFromJSONTyped,
    WidgetDataAttendanceWidgetDataToJSON,
    WidgetDataAttendanceWidgetDataToJSONTyped,
} from './WidgetDataAttendanceWidgetData';
import type { WidgetDataLowEnrollmentClassesWidgetData } from './WidgetDataLowEnrollmentClassesWidgetData';
import {
    WidgetDataLowEnrollmentClassesWidgetDataFromJSON,
    WidgetDataLowEnrollmentClassesWidgetDataFromJSONTyped,
    WidgetDataLowEnrollmentClassesWidgetDataToJSON,
    WidgetDataLowEnrollmentClassesWidgetDataToJSONTyped,
} from './WidgetDataLowEnrollmentClassesWidgetData';
import type { RevenueMonthData } from './RevenueMonthData';
import {
    RevenueMonthDataFromJSON,
    RevenueMonthDataFromJSONTyped,
    RevenueMonthDataToJSON,
    RevenueMonthDataToJSONTyped,
} from './RevenueMonthData';
import type { WidgetDataEnrollmentStatusBreakdownWidgetData } from './WidgetDataEnrollmentStatusBreakdownWidgetData';
import {
    WidgetDataEnrollmentStatusBreakdownWidgetDataFromJSON,
    WidgetDataEnrollmentStatusBreakdownWidgetDataFromJSONTyped,
    WidgetDataEnrollmentStatusBreakdownWidgetDataToJSON,
    WidgetDataEnrollmentStatusBreakdownWidgetDataToJSONTyped,
} from './WidgetDataEnrollmentStatusBreakdownWidgetData';
import type { WidgetDataStudentsProgressWidgetData } from './WidgetDataStudentsProgressWidgetData';
import {
    WidgetDataStudentsProgressWidgetDataFromJSON,
    WidgetDataStudentsProgressWidgetDataFromJSONTyped,
    WidgetDataStudentsProgressWidgetDataToJSON,
    WidgetDataStudentsProgressWidgetDataToJSONTyped,
} from './WidgetDataStudentsProgressWidgetData';
import type { WidgetDataClassesCalendarWidgetData } from './WidgetDataClassesCalendarWidgetData';
import {
    WidgetDataClassesCalendarWidgetDataFromJSON,
    WidgetDataClassesCalendarWidgetDataFromJSONTyped,
    WidgetDataClassesCalendarWidgetDataToJSON,
    WidgetDataClassesCalendarWidgetDataToJSONTyped,
} from './WidgetDataClassesCalendarWidgetData';
import type { WidgetDataTopClassesWidgetData } from './WidgetDataTopClassesWidgetData';
import {
    WidgetDataTopClassesWidgetDataFromJSON,
    WidgetDataTopClassesWidgetDataFromJSONTyped,
    WidgetDataTopClassesWidgetDataToJSON,
    WidgetDataTopClassesWidgetDataToJSONTyped,
} from './WidgetDataTopClassesWidgetData';
import type { WidgetDataActiveSeasonsWidgetData } from './WidgetDataActiveSeasonsWidgetData';
import {
    WidgetDataActiveSeasonsWidgetDataFromJSON,
    WidgetDataActiveSeasonsWidgetDataFromJSONTyped,
    WidgetDataActiveSeasonsWidgetDataToJSON,
    WidgetDataActiveSeasonsWidgetDataToJSONTyped,
} from './WidgetDataActiveSeasonsWidgetData';
import type { WidgetDataToDoWidgetData } from './WidgetDataToDoWidgetData';
import {
    WidgetDataToDoWidgetDataFromJSON,
    WidgetDataToDoWidgetDataFromJSONTyped,
    WidgetDataToDoWidgetDataToJSON,
    WidgetDataToDoWidgetDataToJSONTyped,
} from './WidgetDataToDoWidgetData';
import type { WidgetDataRecentActivityWidgetData } from './WidgetDataRecentActivityWidgetData';
import {
    WidgetDataRecentActivityWidgetDataFromJSON,
    WidgetDataRecentActivityWidgetDataFromJSONTyped,
    WidgetDataRecentActivityWidgetDataToJSON,
    WidgetDataRecentActivityWidgetDataToJSONTyped,
} from './WidgetDataRecentActivityWidgetData';
import type { WidgetDataRevenueHistoryWidgetData } from './WidgetDataRevenueHistoryWidgetData';
import {
    WidgetDataRevenueHistoryWidgetDataFromJSON,
    WidgetDataRevenueHistoryWidgetDataFromJSONTyped,
    WidgetDataRevenueHistoryWidgetDataToJSON,
    WidgetDataRevenueHistoryWidgetDataToJSONTyped,
} from './WidgetDataRevenueHistoryWidgetData';
import type { WidgetDataTeacherLoadWidgetData } from './WidgetDataTeacherLoadWidgetData';
import {
    WidgetDataTeacherLoadWidgetDataFromJSON,
    WidgetDataTeacherLoadWidgetDataFromJSONTyped,
    WidgetDataTeacherLoadWidgetDataToJSON,
    WidgetDataTeacherLoadWidgetDataToJSONTyped,
} from './WidgetDataTeacherLoadWidgetData';
import type { WidgetDataEnrollmentsCalendarWidgetData } from './WidgetDataEnrollmentsCalendarWidgetData';
import {
    WidgetDataEnrollmentsCalendarWidgetDataFromJSON,
    WidgetDataEnrollmentsCalendarWidgetDataFromJSONTyped,
    WidgetDataEnrollmentsCalendarWidgetDataToJSON,
    WidgetDataEnrollmentsCalendarWidgetDataToJSONTyped,
} from './WidgetDataEnrollmentsCalendarWidgetData';
import type { ToDoTaskRow } from './ToDoTaskRow';
import {
    ToDoTaskRowFromJSON,
    ToDoTaskRowFromJSONTyped,
    ToDoTaskRowToJSON,
    ToDoTaskRowToJSONTyped,
} from './ToDoTaskRow';
import type { WidgetDataClassroomUtilizationWidgetData } from './WidgetDataClassroomUtilizationWidgetData';
import {
    WidgetDataClassroomUtilizationWidgetDataFromJSON,
    WidgetDataClassroomUtilizationWidgetDataFromJSONTyped,
    WidgetDataClassroomUtilizationWidgetDataToJSON,
    WidgetDataClassroomUtilizationWidgetDataToJSONTyped,
} from './WidgetDataClassroomUtilizationWidgetData';
import type { WidgetDataUpcomingClassesWidgetData } from './WidgetDataUpcomingClassesWidgetData';
import {
    WidgetDataUpcomingClassesWidgetDataFromJSON,
    WidgetDataUpcomingClassesWidgetDataFromJSONTyped,
    WidgetDataUpcomingClassesWidgetDataToJSON,
    WidgetDataUpcomingClassesWidgetDataToJSONTyped,
} from './WidgetDataUpcomingClassesWidgetData';
import type { WidgetDataRevenueWidgetData } from './WidgetDataRevenueWidgetData';
import {
    WidgetDataRevenueWidgetDataFromJSON,
    WidgetDataRevenueWidgetDataFromJSONTyped,
    WidgetDataRevenueWidgetDataToJSON,
    WidgetDataRevenueWidgetDataToJSONTyped,
} from './WidgetDataRevenueWidgetData';
import type { WidgetDataRecentPendingEnrollmentsWidgetData } from './WidgetDataRecentPendingEnrollmentsWidgetData';
import {
    WidgetDataRecentPendingEnrollmentsWidgetDataFromJSON,
    WidgetDataRecentPendingEnrollmentsWidgetDataFromJSONTyped,
    WidgetDataRecentPendingEnrollmentsWidgetDataToJSON,
    WidgetDataRecentPendingEnrollmentsWidgetDataToJSONTyped,
} from './WidgetDataRecentPendingEnrollmentsWidgetData';
import type { WidgetDataClassCapacityWidgetData } from './WidgetDataClassCapacityWidgetData';
import {
    WidgetDataClassCapacityWidgetDataFromJSON,
    WidgetDataClassCapacityWidgetDataFromJSONTyped,
    WidgetDataClassCapacityWidgetDataToJSON,
    WidgetDataClassCapacityWidgetDataToJSONTyped,
} from './WidgetDataClassCapacityWidgetData';
import type { WidgetDataWaitlistWidgetData } from './WidgetDataWaitlistWidgetData';
import {
    WidgetDataWaitlistWidgetDataFromJSON,
    WidgetDataWaitlistWidgetDataFromJSONTyped,
    WidgetDataWaitlistWidgetDataToJSON,
    WidgetDataWaitlistWidgetDataToJSONTyped,
} from './WidgetDataWaitlistWidgetData';
import type { WidgetDataCountWidgetData } from './WidgetDataCountWidgetData';
import {
    WidgetDataCountWidgetDataFromJSON,
    WidgetDataCountWidgetDataFromJSONTyped,
    WidgetDataCountWidgetDataToJSON,
    WidgetDataCountWidgetDataToJSONTyped,
} from './WidgetDataCountWidgetData';
import type { WidgetDataNewEnrollmentsWidgetData } from './WidgetDataNewEnrollmentsWidgetData';
import {
    WidgetDataNewEnrollmentsWidgetDataFromJSON,
    WidgetDataNewEnrollmentsWidgetDataFromJSONTyped,
    WidgetDataNewEnrollmentsWidgetDataToJSON,
    WidgetDataNewEnrollmentsWidgetDataToJSONTyped,
} from './WidgetDataNewEnrollmentsWidgetData';
import type { WidgetDataScheduledDropEnrollmentsWidgetData } from './WidgetDataScheduledDropEnrollmentsWidgetData';
import {
    WidgetDataScheduledDropEnrollmentsWidgetDataFromJSON,
    WidgetDataScheduledDropEnrollmentsWidgetDataFromJSONTyped,
    WidgetDataScheduledDropEnrollmentsWidgetDataToJSON,
    WidgetDataScheduledDropEnrollmentsWidgetDataToJSONTyped,
} from './WidgetDataScheduledDropEnrollmentsWidgetData';
import type { WidgetDataLocationUsageWidgetData } from './WidgetDataLocationUsageWidgetData';
import {
    WidgetDataLocationUsageWidgetDataFromJSON,
    WidgetDataLocationUsageWidgetDataFromJSONTyped,
    WidgetDataLocationUsageWidgetDataToJSON,
    WidgetDataLocationUsageWidgetDataToJSONTyped,
} from './WidgetDataLocationUsageWidgetData';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface WidgetData
 */
export interface WidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetData
     */
    $type: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WidgetData
     */
    total: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof WidgetData
     */
    totalRefunds: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetData
     */
    totalPayments: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetData
     */
    revenue: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetData
     */
    totalCredits: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetData
     */
    totalDebits: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetData
     */
    openBalance: number;
    /**
     * 
     * @type {Date}
     * @memberof WidgetData
     */
    periodStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof WidgetData
     */
    periodEnd: Date;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WidgetData
     */
    membersWithOpenBalance: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof WidgetData
     */
    classRevenue: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetData
     */
    ticketRevenue: number;
    /**
     * 
     * @type {Array<ToDoTaskRow>}
     * @memberof WidgetData
     */
    items: Array<ToDoTaskRow>;
    /**
     * 
     * @type {Array<RevenueMonthData>}
     * @memberof WidgetData
     */
    months: Array<RevenueMonthData>;
}



/**
 * Check if a given object implements the WidgetData interface.
 */
export function instanceOfWidgetData(value: object): value is WidgetData {
    if (!('$type' in value) || value['$type'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('totalRefunds' in value) || value['totalRefunds'] === undefined) return false;
    if (!('totalPayments' in value) || value['totalPayments'] === undefined) return false;
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    if (!('totalCredits' in value) || value['totalCredits'] === undefined) return false;
    if (!('totalDebits' in value) || value['totalDebits'] === undefined) return false;
    if (!('openBalance' in value) || value['openBalance'] === undefined) return false;
    if (!('periodStart' in value) || value['periodStart'] === undefined) return false;
    if (!('periodEnd' in value) || value['periodEnd'] === undefined) return false;
    if (!('membersWithOpenBalance' in value) || value['membersWithOpenBalance'] === undefined) return false;
    if (!('classRevenue' in value) || value['classRevenue'] === undefined) return false;
    if (!('ticketRevenue' in value) || value['ticketRevenue'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('months' in value) || value['months'] === undefined) return false;
    return true;
}

export function WidgetDataFromJSON(json: any): WidgetData {
    return WidgetDataFromJSONTyped(json, false);
}

export function WidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetData {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        
        '$type': json['$type'],
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
        'totalRefunds': json['totalRefunds'],
        'totalPayments': json['totalPayments'],
        'revenue': json['revenue'],
        'totalCredits': json['totalCredits'],
        'totalDebits': json['totalDebits'],
        'openBalance': json['openBalance'],
        'periodStart': (new Date(json['periodStart'])),
        'periodEnd': (new Date(json['periodEnd'])),
        'membersWithOpenBalance': ApiUserTasksGetPageParameterFromJSON(json['membersWithOpenBalance']),
        'classRevenue': json['classRevenue'],
        'ticketRevenue': json['ticketRevenue'],
        'items': ((json['items'] as Array<any>).map(ToDoTaskRowFromJSON)),
        'months': ((json['months'] as Array<any>).map(RevenueMonthDataFromJSON)),
    };
}

export function WidgetDataToJSON(json: any): WidgetData {
    return WidgetDataToJSONTyped(json, false);
}

export function WidgetDataToJSONTyped(value?: WidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['$type']) {
            default:
                return value;
        }
    }

    return {
        
        '$type': value['$type'],
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
        'totalRefunds': value['totalRefunds'],
        'totalPayments': value['totalPayments'],
        'revenue': value['revenue'],
        'totalCredits': value['totalCredits'],
        'totalDebits': value['totalDebits'],
        'openBalance': value['openBalance'],
        'periodStart': value['periodStart'].toISOString().substring(0,10),
        'periodEnd': value['periodEnd'].toISOString().substring(0,10),
        'membersWithOpenBalance': ApiUserTasksGetPageParameterToJSON(value['membersWithOpenBalance']),
        'classRevenue': value['classRevenue'],
        'ticketRevenue': value['ticketRevenue'],
        'items': ((value['items'] as Array<any>).map(ToDoTaskRowToJSON)),
        'months': ((value['months'] as Array<any>).map(RevenueMonthDataToJSON)),
    };
}

